import React from "react";
import { useHistory } from "react-router-dom";

export default function EmailCapture(props) {
  const history = useHistory();
  return (
    <div className={`flex my-5 ${props.className} `}>
      <form
        className="flex items-center bg-gray-600  backdrop-filter backdrop-blur-lg rounded-lg  z-10"
        onSubmit={(e) => {
          e.preventDefault();
          let email = e.target.email.value;
          history.push("/createacc?emailid=" + email);
        }}
      >
        <div>
          <input
            required
            name="email"
            type="email"
            className="w-full bg-gray-600 border-none h-[60px] backdrop-filter backdrop-blur-lg md:max-w-[300px] rounded-l-lg px-2 text-white text-lg focus:outline-none"
            placeholder="Email"
          ></input>
        </div>
        <div>
          <button
            type="submit"
            className="flex items-center gap-x-2 border-none bg-pb-primary-100  shimmer-auto  py-3 px-4 rounded-lg text-white w-max font-bold hover:bg-[#1e886a] transition-all cursor-pointer mr-2"
          >
            {" "}
            <img
              src={
                require("../../assets/optimized/Landing/Hero Section/Navbar Icons/signIn-icon.svg")
                  .default
              }
            ></img>
            Get Started
          </button>
        </div>
      </form>
    </div>
  );
}
